import { Interview } from '../../../../../entities/Interview';
import { EmptyTab } from '../../../../../components/EmptyTab';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { ActionPoints } from '../../../../../components/ActionPoints';
import React from 'react';
import { ActionPoint } from '../../../../../entities/ActionPoint';

interface PropTypes {
  interview: Interview;
  atsEnabled: boolean;
  onSelectTimestamp: (timestamp: number) => void;
  onUpdateActionPoints: (actionPoints: ActionPoint[]) => void;
  openExternalLink?: boolean;
}

function ActionPointsEmptyState() {
  return (
    <EmptyTab
      title='No Action Points available yet'
      text='We are processing the interview action points. Please check back later.'
    />
  );
}

export function ActionPointsTab(props: PropTypes) {
  return (
    <div
      className={classNames(
        'd-flex',
        'flex-column',
        'gap-3',
        'mt-4',
        styles.expandableNotes,
      )}
    >
      {props.interview.actionPoints.length === 0 ? (
        <ActionPointsEmptyState />
      ) : (
        <>
          {props.interview.actionPoints?.length > 0 && (
            <div className='fs-4 fw-bold'>Action Points</div>
          )}
          <ActionPoints
            interview={props.interview}
            onUpdateActionPoints={props.onUpdateActionPoints}
            atsEnabled={props.atsEnabled}
            openExternalLink={props.openExternalLink}
          />
        </>
      )}
    </div>
  );
}
